import { createContext } from "react";

export const InvestCalculationContext = createContext();

